import { z } from 'zod/v4';

export const lookupTypeSchema = z.enum([
  'estimators',
  'business-units',
  'work-types',
]);

export type LookupType = z.infer<typeof lookupTypeSchema>;

export const createLookupSchema = z.object({
  name: z.string().min(1).max(255),
});

export const updateLookupSchema = z.object({
  name: z.string().min(1).max(255),
});
